(() => {
  'use strict';
  const copy = JSON.parse(document.getElementById('CTOHumanCopy').textContent);
  const phoneValid = value => /^\+?[\d\s().-]+$/.test(value.trim()) && value.replace(/\D/g,'').length >= 7 && value.replace(/\D/g,'').length <= 15;
  const summary = form => {
    const parts = [copy.wa_intro];
    [...form.elements].forEach(field => {
      if (field.disabled || !field.value || !field.name?.startsWith('contact[') || /\[(?:name|email|Telephone|phone|Origine|Contact souhaite)\]/i.test(field.name)) return;
      if (field.type === 'checkbox' || field.type === 'radio') { if (!field.checked) return; }
      const label = field.name === 'contact[body]' ? copy.contact_message : field.name.slice(8,-1);
      const value = field.tagName === 'SELECT' ? field.selectedOptions[0]?.textContent : field.value;
      if (value) parts.push(`${label} : ${String(value).trim().slice(0,1500)}`);
    });
    return parts.join('\n').slice(0,3500);
  };
  const init = (scope = document) => {
    scope.querySelectorAll('[data-human-contact]').forEach(root => {
      if (root.dataset.ready) return; root.dataset.ready = 'true';
      const form = root.closest('form'); if (!form) return;
      const phone = root.querySelector('input[type=tel]');
      const email = root.querySelector('input[type=email]');
      const native = root.querySelector('[data-human-native]');
      const wa = root.querySelector('[data-human-whatsapp]');
      const update = method => {
        form.dataset.humanMode = method;
        root.querySelector('[data-human-method]').value = method === 'call' ? copy.call : copy.email;
        root.querySelectorAll('[data-contact-method]').forEach(button => button.setAttribute('aria-pressed',String(button.dataset.contactMethod === method)));
        native.hidden = method === 'whatsapp'; wa.hidden = method !== 'whatsapp';
        native.querySelectorAll('input').forEach(field => { field.disabled = method === 'whatsapp'; });
        phone.disabled = method !== 'call'; phone.required = method === 'call'; root.querySelector('[data-human-phone-wrap]').hidden = method !== 'call';
        root.querySelector('[data-human-email-help]').hidden = method !== 'call';
        phone.setCustomValidity(phone.required && phone.value && !phoneValid(phone.value) ? copy.phone_error : '');
        const label = form.querySelector('[data-planner-send-label]') || form.querySelector('button[type=submit]');
        if (label) label.textContent = method === 'call' ? copy.call_send : copy.email_send;
        email.required = true;
      };
      root.querySelectorAll('[data-contact-method]').forEach(button => button.addEventListener('click',() => update(button.dataset.contactMethod)));
      phone.addEventListener('input',() => phone.setCustomValidity(phone.required && phone.value && !phoneValid(phone.value) ? copy.phone_error : ''));
      root.querySelector('[data-human-wa]').addEventListener('click',event => {
        event.currentTarget.href = 'https://wa.me/33659584801?text=' + encodeURIComponent(summary(form));
        window.CTOFormUX.feedback(form,'info',copy.wa_ready);
      });
      form.addEventListener('submit',event => {
        if (form.dataset.humanMode !== 'whatsapp') return;
        event.preventDefault(); event.stopImmediatePropagation();
        root.querySelector('[data-human-wa]').focus();
      },true);
      update(window.CTOFormReturn?.formId === form.id && window.CTOFormReturn.method === 'email' ? 'email' : 'call');
    });
    const marker = window.CTOFormReturn;
    if (marker?.method === 'call' && marker.formId) {
      const result = document.getElementById(marker.formId)?.querySelector('[data-cto-inquiry-success]');
      if (result) {
        const title = result.querySelector('h3'); if (title) title.textContent = copy.callback_success;
        const text = [...result.querySelectorAll('p')].find(p => !p.querySelector('strong')); if (text) text.textContent = copy.callback_after;
      }
    }
    scope.querySelectorAll('form[action*="/contact"]').forEach(form => {
      if (form.querySelector('[data-human-help]')) return;
      const assistance = document.createElement('a'); assistance.className = 'cto-human-help'; assistance.dataset.humanHelp = ''; assistance.href = 'https://wa.me/33659584801'; assistance.target = '_blank'; assistance.rel = 'noopener noreferrer'; assistance.textContent = copy.human_question;
      if (form.querySelector('[name=form_type]')?.value === 'contact' && !form.querySelector('[data-cto-inquiry-success]')) form.append(assistance);
    });
  };
  window.CTOHumanForms = { copy, phoneValid };
  document.addEventListener('DOMContentLoaded',() => init());
  document.addEventListener('shopify:section:load',event => init(event.target));
})();
